var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarbecue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.086,
    height: 13.684,
    viewBox: "0 0 14.086 13.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-fire",
    "data-name": "Icon metro-fire",
    d: "M8.667,15.612a3.063,3.063,0,0,1,.326-4.01A5.864,5.864,0,0,0,10.137,9.37a2.316,2.316,0,0,1,.429,2.011,4.518,4.518,0,0,0,1.312-3.8c2.857,1.684,4.078,5.33,2.432,8.032,8.751-4.176,2.177-10.426,1.032-11.129a2.006,2.006,0,0,1-.317,2.474,7.245,7.245,0,0,0-4.531-5.028C10.876,4.08,9.111,6.433,7.41,8.192A4.079,4.079,0,0,0,6.752,5.92c-.12,1.559-1.533,2.83-1.915,4.391C4.318,12.427,5.225,13.976,8.667,15.612Z",
    transform: "translate(-4.701 -1.928)",
    fill: "#cea95a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarbecue);
export default __webpack_public_path__ + "static/media/barbecue.edab4140cecdbb8942bba3e4c3e23bec.svg";
export { ForwardRef as ReactComponent };